import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { MessageType } from '../../../../_model/message/message.model';
import { ResourceService } from '../../../../_service/resource/resource.service';
import { Router, NavigationEnd } from '@angular/router';
import { NotificationService } from '../../../../_service/notification/notification.service';
import { ToastService } from '../../../../_service/toast/toast.service';
import { AppStore } from '../../../../app.store';
import * as RefReplyActions from '../../../../_model/reply/replay.actions';
import { Subscription } from 'rxjs';
import { SocketFacade } from 'app/_modules/socket/socket.facade';
import { FavoriteService } from 'app/_service/favorite/favorite.service';
import { Utility } from '../../../../_service/utility';
import { UserService } from '../../../../_service/user/user.service';
import { RefReplyState } from '../../../../app.reducer';
import { Store } from 'redux';

@Component({
  selector: 'app-dropdown-notifications-messages',
  templateUrl: './dropdown-notifications-messages.component.html',
  styleUrls: ['./dropdown-notifications-messages.component.scss',"../dropdown-share.scss"]
})
export class DropdownNotificationsMessagesComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription> = [];
  public _messageType = MessageType;
  user;
  messages:Array<any> = [];
  // sub;
  @Input() data: any;
  hasNewMessages = false;
  concatsHasUnreadMessage = []
  //showOldStyle = false;
  windowActive = true;
  constructor(
    public _resourceService: ResourceService,
    private _router: Router,
    private _notificationService: NotificationService,
    private _toastService: ToastService,
    // private _dnEmojiService: DnEmojiService,
    @Inject(AppStore) private store: Store<RefReplyState>,
    private socketFacade: SocketFacade,
    private _favoriteService: FavoriteService,
    private _userService:UserService,
    private _utility:Utility
  ) {
    // this.sub = store.subscribe(() => this.readState());
    // this.readState();
    window.onblur = () => {
      this.windowActive = false;
      // console.log('非活动窗口');
    };
    window.onfocus = () => {
      this.windowActive = true;
      // console.log('活动窗口');
    };
  }

  readState() {
   
  }

  ngOnInit() {

    this.user = this._userService.user;
    this.subscriptions.push(
      this.socketFacade.concatsHasUnreadMessage$.subscribe(r => {
        this.concatsHasUnreadMessage = r;
        // console.log(this.concatsHasUnreadMessage);
      }),
      this.socketFacade.hasNewMessages$.subscribe(r => this.hasNewMessages = r),
      // this._router.events.subscribe(
      //   (event) => {

      //     if (event instanceof NavigationEnd) {
      //       const url = event.urlAfterRedirects.split('?')[0];
      //       if (url === '/user/messages/chat') {
      //         this.hasNewMessages = false;
      //         this.concatsHasUnreadMessage = [];
      //       }
      //     }

      //   }
      // ),
      this._utility.GetOrCreateSubscript("user.newMessage").subscribe(p => {

        if (this.windowActive) {
          console.log('活动窗口');
          this.getNewMessage();
        } else {
          console.log('非活动窗口');
        }
      }),
      this._userService.userState$.subscribe(user=>{
        this.user = user;
        this.getNewMessage();
      }),
      this._userService.notificationState$.subscribe(p=>{
        this.notify = p;
      }),
      this._notificationService.enterMsgClearNotification$.subscribe(p => {
        if (!!p) {
          // 通过强提醒点击后，清除私信通知
          const privateMsgs = this.messages.filter(s => s.actType === 12 && s.isRemind === 1); // 只取带强提醒的私信
          if (privateMsgs.length > 0) {
            this._favoriteService.updateFavoriteAttentionNotify(privateMsgs[0].msgID, 1, 12).subscribe(r => {
              // this.messages = this.messages.filter(s => s.actType !== 12); // 私信，清除其他私信
              this.messages = this.messages.filter(s => s.msgID !== privateMsgs[0].msgID); // 私信，只清除该条私信
              this._userService.updateNotify({
                messages: this.notify.messages > 0 ? this.messages.length : 0,
                pm: this.messages.filter(s => s.actType === 12 && s.isRemind === 1).length, // 只取带强提醒的私信
              });
            });
          }
        }
      }),
    );

  }

  notify ={
    messages:0
  };
  getNewMessage() {

    if(this.user.id>0)
    {
      this._notificationService.getOtherNotifications(this.user)
      .subscribe(res => {

        this.messages = res.map(r => {
          return {
            ...r,
            lidName: !!r.lidName ? r.lidName : '',
          }
        });
        // console.log(this.messages);
        this._userService.updateNotify({
          messages:this.messages.length,
          pm: this.messages.filter(s => s.actType === 12 && s.isRemind === 1).length, // 只取带强提醒的私信
        })
      }

      )
    }
    else
    {
      this.messages = [];
      this._userService.updateNotify({
        messages:this.messages.length,
        pm: 0,
      })
    }
   
   
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    // this.sub();
  }

  clearMessageNotifications() {
    this.socketFacade.MarkAllMessagesAsRead();
    if (!this.messages?.length) {
      return;
    }

    this._notificationService.newMarkAllNotificationsAsRead(this.user).subscribe(r => {
      if (r.code !== 1) {
        this._toastService.showBlackToast('已清空！');
        this.messages = [];
        this._userService.updateNotify({
          messages:0,
          pm: 0,
        })
      }
    });

  }

  showComment(item) {
    if (item.type === 2) {
      // this._router.navigate(['/user/messages'], { queryParams: { type: 3 } });
      this._router.navigate(['/user/messages/3']);
      return;
    }
    // this._router.navigate(['/detail'], { queryParams: { id: item.video.key } });
    this._router.navigate(['/user/messages/2']);
    this.store.dispatch({
      type: RefReplyActions.REFREPLY, reply: {
        author: item.user.name,
        authorId: item.user.id,
        avatar: item.user.avatar,
        commendId: item.comment.id,
        content: '<span class="text-green">' + '回复了您 [ @ ' + item.comment.reply.floor + ' 楼 ]</span> ' + item.content,
        deleted: undefined,
        floor: item.comment.floor,
        liked: undefined,
        likes: item.comment.likes,
        published: item.timestamp,
        replyId: item.comment.id,
        userLevelSymbol: undefined,
        videoId: item.video.key,
        notificationId: item.notificationId
      }
    });
  }

  msgClick(item) {
    // console.log(item);
    switch (item.actType) {
      case 0:
        this._router.navigate(['/user/messages/3']);
        break;
      case 101:
        this._router.navigate(['/user/messages/2']);
        break;
      case 12:
        this._router.navigate(['/user/messages/chat'], { queryParams: { id: item.uidStr } });
        break;
      case 8:
        this._router.navigate(['/user/messages/3']);
        break;
      case 13:
        this._router.navigate(['/rank/all']);
        break;
      case 14:
        this._router.navigate(['/vip-center/index']);
        break;
      case 15:
        this._router.navigate(['/user/messages/4']);
        break;
      case 16:
        this._router.navigate(['/user/messages/4']);
        break;
      case 17:
        this._router.navigate(['/user/messages/4']);
        break;
      case 18:
        this._router.navigate(['/user/messages/4']);
        break;
      case 19:
        this._router.navigate(['/user/messages/4']);
        break;
      default:
        if (item.cid === 1) {
          this._router.navigate(['/play',item.lidStr], { fragment: item.actType === 6 ? 'comments' : null });
        }
        if (item.cid === 3) {
          this._router.navigate(['/watch'], { queryParams: { v: item.lidStr }, fragment: item.actType === 6 ? 'comments' : null });
        }
        break;
    }

    this._favoriteService.updateFavoriteAttentionNotify(item.msgID, 1, item.actType).subscribe(r => {
      // console.log(r);
      const ifPM = item.actType === 12;
      const ifMyVideoHasComment = item.actType === 6;
      if (ifPM) {
        // this.messages = this.messages.filter(s => s.actType !== 12); // 私信，清除其他私信
        this.messages = this.messages.filter(s => s.msgID !== item.msgID); // 私信，只清除该条私信
      } else {
        if (ifMyVideoHasComment) {
          this.messages = this.messages.filter(s => s.vid !== item.vid); // 清除我的同一个视频下的评论提醒
        } else {
          this.messages = this.messages.filter(s => s.msgID !== item.msgID);
        }
      }
      this._userService.updateNotify({
        messages: this.notify.messages>0?(ifPM || ifMyVideoHasComment)? this.messages.length:this.notify.messages -1:0,//this.user.notifications.messages > 0 ? (ifPM || ifMyVideoHasComment) ? this.messages.length : this.user.notifications.messages - 1 : 0
        pm: this.messages.filter(s => s.actType === 12 && s.isRemind === 1).length, // 只取带强提醒的私信
      });
      
      // this.store.dispatch({
      //   type: userActions.UPDATENOTIFICATIONS, notifications: {
      //     favorites: this.user.notifications.favorites,
      //     messages: this.user.notifications.messages > 0 ? (ifPM || ifMyVideoHasComment) ? this.messages.length : this.user.notifications.messages - 1 : 0,
      //   }
      // });
    });
  }

  navToActivity(item) {
    this._router.navigate(['/space/', item.uidStr], { queryParams: { type: 'activity', pid: item.lid} });
    this._favoriteService.updateFavoriteAttentionNotify(item.msgID, 3, item.actType).subscribe(r => {
      this.messages = this.messages.filter(s => s.msgID !== item.msgID);
      this._userService.updateNotify({
        messages: this.messages.length,
      });
    });
  }

  navToAlbum(item) {
    this._router.navigate(['/space/', item.uidStr], { queryParams: { type: 'album', a: item.lid} });
    this._favoriteService.updateFavoriteAttentionNotify(item.msgID, 3, item.actType).subscribe(r => {
      this.messages = this.messages.filter(s => s.msgID !== item.msgID);
      this._userService.updateNotify({
        messages: this.messages.length,
      });
    });
  }

  nameClick(e) {
    e.stopPropagation();
  }

  markAllPrivateMessagesAsRead() {
    this.socketFacade.MarkAllMessagesAsRead();
  }

  markPrivateMessagesAsRead(item) {
    this.socketFacade.MarkMessagesAsRead({ uid: item.plainUserId })
  }

  getMembership(gid) {
    let membership = '';
    switch (gid) {
      case 0:
        membership = '';
        break;
      case 1:
        membership = 'gvip';
        break;
      case 2:
        membership = 'gvip';
        break;
      case 3:
        membership = 'royalVip';
        break;
      case 4:
        membership = 'cpvip';
        break;
      case 101:
        membership = 'cpvip';
        break;
      case 102:
        membership = 'cpvip';
        break;
      default:
        membership = 'vip';
    }
    return membership;
  }
}
